import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import translateText from './translateText';
import { parseJson } from '../utils/string/parseJson';

// Cache để lưu trữ các translation đã dịch
const translationCache = new Map();

const SmartTranslate = ({ text, sourceLang = 'vi', targetLang = 'en' }) => {
  const { t, i18n } = useTranslation();
  const [translated, setTranslated] = useState(text);

  useEffect(() => {
    try {
      const parseText = parseJson(text);
      if (parseText.vi || parseText.en) {
        const cacheKey = `${sourceLang}:${targetLang}:${parseText[targetLang]}`;

        translationCache.set(cacheKey, parseText[targetLang]);
        setTranslated(parseText[targetLang]);
      } else throw new Error('Invalid text format');
    } catch {
      // Tạo cache key từ text, sourceLang và targetLang
      const cacheKey = `${sourceLang}:${targetLang}:${text}`;

      // Kiểm tra cache trước
      if (translationCache.has(cacheKey)) {
        setTranslated(translationCache.get(cacheKey));
        return;
      }

      // Nếu không có trong cache, gọi API dịch
      translateText(text, sourceLang, targetLang)
        .then(result => {
          // Lưu vào cache
          translationCache.set(cacheKey, result);
          setTranslated(result);
        })
        .catch(error => {
          console.error('Translation failed:', error);
          setTranslated(text); // Fallback về text gốc nếu dịch thất bại
        });
    }
  }, [text, sourceLang, targetLang]);

  return translated;
};

export default SmartTranslate;
